import PropTypes from 'prop-types'

const logbookRemark = PropTypes.shape({
  categoryId: PropTypes.number,
  loggedAt: PropTypes.string.isRequired,
  remark: PropTypes.string.isRequired,
})

export default PropTypes.arrayOf(logbookRemark)
